import { serializeIdentifier } from "../../corePlugins/useChartSeries/serializeIdentifier.js";
export const visibilityParamToMap = (hiddenItems, seriesConfig) => {
  const visibilityMap = new Map();
  if (hiddenItems) {
    hiddenItems.forEach(identifier => {
      const uniqueId = serializeIdentifier(seriesConfig, identifier);
      visibilityMap.set(uniqueId, identifier);
    });
  }
  return visibilityMap;
};